function faqCardToggle(e) {
	e.currentTarget.classList.toggle('opened');
}

function arrowTickMorph(unused, elem) {
	const arrow = elem.getElementsByClassName('arrow')[0];
	const tick = elem.getElementsByClassName('tick')[0];
	let morphed = false;

	let nlField = elem;
	while (nlField && !nlField.classList.contains('ui-kit-newsletter-input'))
		nlField = nlField.parentElement;
	if (nlField) nlField.svgMorphable = elem;
	elem.MorphToTick = () => {
		if (morphed) return;
		morphed = true;
		gsap.to(arrow, {
			duration: 0.4,
			morphSVG: {
				shape: tick,
				shapeIndex: [0],
				precompile: [
					'M19.5812,1.3 C22.18683,3.7 24.79247,6.1 27.3981,8.5 24.79247,10.9 22.18683,13.3 19.5812,15.7 M0.86853,8.5 C9.71172,8.5 18.55491,8.5 27.3981,8.5 ',
					'M6.66,8.56 C6.66,8.56 13.06,14.47 13.06,14.47 13.06,14.47 23.69,2.59 23.69,2.59 M13.06,14.47 C13.06,14.47 13.06,14.47 13.06,14.47 ',
				],
			},
		});
	};
}

function setNewsletterMailFields() {
	const nlFields = document.getElementsByClassName('ui-kit-newsletter-input');
	for (let nlField of nlFields) {
		const submitBtn = nlField.getElementsByClassName('submit-btn')[0];
		const innerInput = nlField.getElementsByClassName('mail-field')[0];
		nlField.submitBtn = submitBtn;
		function submit() {
			if (!innerInput.validity.valid || nlField.getAttribute('data-submited')) return;
			// Logic
			innerInput.blur();
			nlField.svgMorphable?.MorphToTick();
			nlField.setAttribute('data-submited', '');
		}
		function enterSubmit(e) {
			if (e.code == 'Enter') submit();
		}
		innerInput.onkeydown = enterSubmit;
		submitBtn.validate = submit;
		nlField.validate = submit;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	setNewsletterMailFields();
});
